import { readOnly } from '@yola/ws-sdk';
import ImagePositioningTool from '../components/image-positioning-tool';
import isPositioningImage from '../helpers/is-positioning-image';

const imagePositioningToolSettings = {
  matches(element) {
    if (readOnly.verifiers.isReadOnlyModeEnabled()) {
      return false;
    }
    return isPositioningImage(element);
  },
  container: ImagePositioningTool,
};
export default imagePositioningToolSettings;
